import PropTypes from "prop-types"
import React from "react"
// import './Authenticate.css'

import Card from "../../core/Card"

import {
  Col,
  Checkbox,
  Button as AButton,
  Switch,
  DatePicker,
  Select,
  Modal,
  Input,
  Icon as AIcon,
  Tooltip,
  Form,
  Alert,
  Popconfirm,
  Row,
  Progress
} from "antd"
//
// import { Field, reduxForm, submit } from 'redux-form'
// import makeField from '../account/makeField'
import { connect } from "react-redux"
// import {Link} from 'react-router-dom';
// import Line from '../core/Line'
// import { login } from './actions'
import styled from "styled-components"
// import TextAppLink from '../home/TextAppLink'
import { push, go } from "react-router-redux"
// LOCAL IMPORTS:

// import {BusinessLine, CustomLine} from '../account/business-lines/BusinessLines'
// import { save, addCustom, toggle } from '../account/business-lines/actions'
// STYLES:

export const Button = styled(AButton).attrs({
  type: props => props.primary && "primary"
})`
  ${props =>
    props.link &&
    `
    background-color: transparent;
    border: none;
    box-shadow: none;
    color: #444444;
  `}
  ${props =>
    props.pullRight &&
    `
    float: right;
  `}
  ${props =>
    props.fullWidth &&
    `
    width: 100%;
    height: 42px;
  `}

`

export const Steps = styled.div`
  display: flex;
  flex-wrap: wrap;
  color: grey;
  justify-content: space-between;
  h1 {
    text-transform: none;
  }
`

export const StepContainer = styled.div`
  display: flex;
  justify-content: space-around;
  > div {
    flex-basis: 800px;
  }
  ${props =>
    props.swiped &&
    `
    opacity: .8;
    perspective: 100vw;
    overflow: hidden;
    > div {
      // transform: translate3d(0,5px,-718px) rotateY(-12deg);
      transform: translate3d(-11vw,20vw,-5vw) rotateY(-10deg);
      transform-style: preserve-3d;
      transition: all 0.5s;
      overflow: hidden;
    }
  `} ${props =>
    props.swipedRight &&
    `
    opacity: .7;
    perspective: 100vw;
    overflow: hidden;
    > div {
      transform: translate3d(-11vw,20vw,-5vw) rotateY(-2deg);
      transform-style: preserve-3d;
      transition: all 0.5s;
      overflow: hidden;
    }
  `};
`
export const StepCard = styled(Card)`
  ${"" /* width: 880px; */} .ant-progress-bg {
    background-color: #31b59f;
  }
  .ant-progress-inner {
    background-color: #eef2f5;
  }
  margin-bottom: 30px;
  padding: 4vmin 6vmin;
`

export const TitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  h3 {
    font-size: 30px;
  }
  align-items: center;
`

export const Content = styled.div`
  padding: 6vmin 0;

  ${props =>
    props.spaceOnTop &&
    `
  padding: 8vh 0;

`};
`

const Step = styled.div`
  cursor: pointer;
  ${props =>
    props.active &&
    `
    color: #31B59F;
  `} ${props =>
    props.disabled &&
    `
    cursor: not-allowed;
  `};
`

export const StepProgress = connect()(({ step, dispatch }) => (
  <div>
    <Steps>
      <Step
        disabled={!(step > 1)}
        active={step == 1}
        onClick={() => step > 1 && dispatch(push("step-one"))}
      >
        {/* <code onClick={()=>go(1-step)}>{1-step}</code> */}
        <h2>Step 1</h2>
        <h1>Work Status</h1>
      </Step>
      <Step
        disabled={!(step > 2)}
        active={step == 2}
        onClick={() => step > 2 && dispatch(push("step-two"))}
      >
        {/* <code onClick={()=>dispatch(go(2-step))}>{2-step}</code> */}
        <h2>Step 2</h2>
        <h1>Business Lines</h1>
      </Step>
      <Step disabled active={step == 3}>
        <h2>Step 3</h2>
        <h1>Mobile App</h1>
      </Step>
    </Steps>

    <Progress
      percent={(step == 3 && 80) || (step == 2 && 50) || (step == 1 && 10)}
      status="active"
      showInfo={false}
    />
  </div>
))



// WEBPACK FOOTER //
// ./src/user/steps/index.js